import { render, staticRenderFns } from "./tHeader.vue?vue&type=template&id=06200da2&scoped=true"
import script from "./tHeader.vue?vue&type=script&lang=js"
export * from "./tHeader.vue?vue&type=script&lang=js"
import style0 from "./tHeader.vue?vue&type=style&index=0&id=06200da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06200da2",
  null
  
)

export default component.exports